import React, { useState } from "react";
import {
  EuiForm,
  EuiFormRow,
  EuiFieldText,
  EuiSelect,
  EuiButton,
} from "@elastic/eui";
import axios from "axios";

const CreateAgentForm = ({ course, onSuccess }) => {
  const [configName, setConfigName] = useState("");
  const [mode, setMode] = useState("step-by-step"); 
  const [solutionTolerance, setSolutionTolerance] = useState("solution");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const payload = {
        config_name: configName,
        mode, // ✅ step-by-step, concise, or both
        solution_tolerance: solutionTolerance,
        course_number: course.course_number,
        course_name: course.course_name,
      };

      await axios.post("/api/config/create", payload);
      onSuccess();
    } catch (err) {
      console.error("Failed to create agent:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <EuiForm component="form">
      <EuiFormRow label="Agent Name">
        <EuiFieldText
          value={configName}
          onChange={(e) => setConfigName(e.target.value)}
        />
      </EuiFormRow>

      <EuiFormRow label="Mode">
        <EuiSelect
          options={[
            { value: "step-by-step", text: "Step-by-step" },
            { value: "concise", text: "Concise" },
            { value: "both", text: "Both" },
          ]}
          value={mode}
          onChange={(e) => setMode(e.target.value)}
        />
      </EuiFormRow>

      <EuiFormRow label="Solution Tolerance">
        <EuiSelect
          options={[
            { value: "solution", text: "Solution" },
            { value: "low_solution", text: "Low Solution" },
            { value: "no_solution", text: "No Solution" },
          ]}
          value={solutionTolerance}
          onChange={(e) => setSolutionTolerance(e.target.value)}
        />
      </EuiFormRow>

      <EuiButton onClick={handleSubmit} isLoading={loading} fill>
        Create Agent
      </EuiButton>
    </EuiForm>
  );
};

export default CreateAgentForm;
